import React from 'react';

export const SidebarArrow = ({
  fill='var(--grey7)',
  className,
}) => (
  <svg width="8" height="14" viewBox="0 0 8 14" fill="none" className={className}>
    <path fill={ fill } d="M8 2L3 7L8 12L7 14L0 7L7 0L8 2Z"/>
  </svg>
);


export const SelectArrow = ({
  fill='var(--grey10)',
  className,
}) => (
  <svg width="7" height="12" viewBox="0 0 7 12" fill="none" className={className}>
    <path d="M7 1.71429L2.625 6L7 10.2857L6.125 12L0 6L6.125 0L7 1.71429Z" fill={fill}/>
  </svg>
);


export const TickMarkCircle = ({
  fill='var(--grey10)',
  className,
}) => (
  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" className={className}>
    <path fillRule="evenodd" clipRule="evenodd" d="M0 6C0 4.4087 0.632141 2.88258 1.75736 1.75736C2.88258 0.632141 4.4087 0 6 0C7.5913 0 9.11742 0.632141 10.2426 1.75736C11.3679 2.88258 12 4.4087 12 6C12 7.5913 11.3679 9.11742 10.2426 10.2426C9.11742 11.3679 7.5913 12 6 12C4.4087 12 2.88258 11.3679 1.75736 10.2426C0.632141 9.11742 0 7.5913 0 6H0ZM5.6576 8.568L9.112 4.2496L8.488 3.7504L5.5424 7.4312L3.456 5.6928L2.944 6.3072L5.6576 8.5688V8.568Z" fill={fill}/>
  </svg>

);

export const TickMarkBlankCircle = ({
  fill='var(--grey10)',
  className,
}) => (
  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" className={className}>
    <circle cx="6" cy="6" r="5.5" stroke={fill}/>
  </svg>
);

export const TickMark = ({
  fill='var(--grey10)',
  className,
}) => (
  <svg width="9" height="8" viewBox="0 0 9 8" fill="none" className={className}>
    <path d="M6.96997 0.970002C7.11084 0.835891 7.2983 0.761749 7.49279 0.76322C7.68728 0.764692 7.8736 0.841662 8.01242 0.97789C8.15124 1.11412 8.23171 1.29895 8.23686 1.49338C8.242 1.68781 8.1714 1.87663 8.03997 2.02L4.04997 7.01C3.98137 7.0839 3.89856 7.1432 3.80651 7.18437C3.71445 7.22553 3.61505 7.24771 3.51423 7.24958C3.41341 7.25145 3.31324 7.23296 3.21973 7.19523C3.12622 7.15751 3.04127 7.10131 2.96997 7.03L0.323975 4.384C0.250288 4.31534 0.191186 4.23254 0.150194 4.14054C0.109202 4.04854 0.0871596 3.94923 0.0853828 3.84852C0.083606 3.74782 0.102131 3.64779 0.139852 3.5544C0.177573 3.46102 0.233718 3.37618 0.304936 3.30496C0.376155 3.23374 0.460989 3.1776 0.554377 3.13988C0.647765 3.10216 0.747794 3.08363 0.848497 3.08541C0.9492 3.08719 1.04851 3.10923 1.14051 3.15022C1.23251 3.19121 1.31531 3.25031 1.38397 3.324L3.47797 5.417L6.95097 0.992002C6.95723 0.984303 6.9639 0.976958 6.97097 0.970002H6.96997Z" fill={fill}/>
  </svg>
);

export const FilterButton = ({
  fill='var(--grey10)',
  className,
}) => (
  <svg width="69" height="69" viewBox="0 0 69 69" fill="none" className={className}>
    <g filter="url(#filter0_d)">
    <circle cx="34.5" cy="31.5" r="24.5" fill="white"/>
    </g>
    <path d="M36.9499 43.75V34.6259L43.9753 26.8534C44.0797 26.7382 44.1622 26.6012 44.2179 26.4503C44.2737 26.2994 44.3015 26.1377 44.2999 25.9748V24.8259C44.2999 24.6466 44.2354 24.4747 44.1205 24.3479C44.0056 24.2212 43.8498 24.15 43.6874 24.15H25.3124C25.15 24.15 24.9942 24.2212 24.8793 24.3479C24.7645 24.4747 24.7 24.6466 24.7 24.8259V25.9545C24.7001 26.1142 24.7288 26.2722 24.7845 26.4195C24.8402 26.5668 24.9218 26.7005 25.0246 26.8129L32.0499 34.6799V41.5737L36.9499 43.75Z" fill="var(--main1)"/>
    <defs>
    <filter id="filter0_d" x="0" y="0" width="69" height="69" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
    <feFlood floodOpacity="0" result="BackgroundImageFix"/>
    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/>
    <feOffset dy="3"/>
    <feGaussianBlur stdDeviation="5"/>
    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"/>
    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow"/>
    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape"/>
    </filter>
    </defs>
  </svg>
);



export const CrossButton = ({
  fill='var(--grey10)',
  className,
}) => (
  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" className={ className }>
<path d="M34.2492 5.83541C26.4494 -1.94514 13.6497 -1.94514 5.84986 5.83541C-1.94995 13.616 -1.94995 26.384 5.84986 34.1646C13.6497 41.9451 26.2494 41.9451 34.0492 34.1646C41.849 26.384 42.049 13.616 34.2492 5.83541V5.83541ZM25.6494 28.3791L20.0495 22.793L14.4497 28.3791L11.6497 25.586L17.2496 20L11.6497 14.414L14.4497 11.6209L20.0495 17.207L25.6494 11.6209L28.4493 14.414L22.8494 20L28.4493 25.586L25.6494 28.3791V28.3791Z" fill="white"/>
</svg>
);


export const Info = ({
  fill='var(--grey10)',
  className,
}) => (
  <svg width="29" height="29" viewBox="0 0 29 29" fill="none">
    <path d="M14.5 1.8125C7.49355 1.8125 1.8125 7.49355 1.8125 14.5C1.8125 21.5064 7.49355 27.1875 14.5 27.1875C21.5064 27.1875 27.1875 21.5064 27.1875 14.5C27.1875 7.49355 21.5064 1.8125 14.5 1.8125ZM14.5 25.0352C8.68301 25.0352 3.96484 20.317 3.96484 14.5C3.96484 8.68301 8.68301 3.96484 14.5 3.96484C20.317 3.96484 25.0352 8.68301 25.0352 14.5C25.0352 20.317 20.317 25.0352 14.5 25.0352Z" fill={fill}/>
    <path d="M13.1406 9.51562C13.1406 9.87615 13.2838 10.2219 13.5388 10.4768C13.7937 10.7318 14.1395 10.875 14.5 10.875C14.8605 10.875 15.2063 10.7318 15.4612 10.4768C15.7162 10.2219 15.8594 9.87615 15.8594 9.51562C15.8594 9.1551 15.7162 8.80933 15.4612 8.5544C15.2063 8.29947 14.8605 8.15625 14.5 8.15625C14.1395 8.15625 13.7937 8.29947 13.5388 8.5544C13.2838 8.80933 13.1406 9.1551 13.1406 9.51562V9.51562ZM15.1797 12.6875H13.8203C13.6957 12.6875 13.5938 12.7895 13.5938 12.9141V20.6172C13.5938 20.7418 13.6957 20.8438 13.8203 20.8438H15.1797C15.3043 20.8438 15.4062 20.7418 15.4062 20.6172V12.9141C15.4062 12.7895 15.3043 12.6875 15.1797 12.6875Z" fill={fill}/>
  </svg>

)
